import {
  HttpClient,
  HttpErrorResponse,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig } from '@ngrx/data';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as Sentry from '@sentry/angular';
import { UserProfile } from '../models/user-profile';

@Injectable()
export class UserProfileService {
  constructor(
    private httpClient: HttpClient,
    private dataServiceConfig: DefaultDataServiceConfig
  ) {}

  userProfileUrl = `${this.dataServiceConfig.root}/userprofiles/by_user`;

  public getUserProfile(): Observable<UserProfile> {
    return this.httpClient.get<UserProfile>(this.userProfileUrl).pipe(
      catchError((err: HttpErrorResponse): Observable<any> => {
        if (err.status === HttpStatusCode.NotFound) {
          return this.newUserProfile();
        }
        Sentry.captureException(err);
        return throwError(() => err);
      })
    );
  }

  public updateUserProfile(userProfile: any) {
    this.httpClient.put(this.userProfileUrl, userProfile).subscribe({
      error: (err) => {
        Sentry.captureException(err);
      },
    });
  }

  private newUserProfile(): Observable<UserProfile> {
    const createUserProfileUrl = `${this.dataServiceConfig.root}/userprofiles`;
    const body = { welcome_shown: false };
    return this.httpClient.post<UserProfile>(createUserProfileUrl, body);
  }
}
